import React, { useMemo } from 'react';

import { Typography, Switch, Table } from 'antd';

import SpinFull from '../../components/SpinFull';

const { Text } = Typography;

export default function StationNotificationSettingTab(props) {
  const {
    station,
    stationNotificationSettings,
    onUpdate,
  } = props;

  const dataSource = useMemo(() => {
    if (!stationNotificationSettings) {
      return [];
    }

    return Object.keys(stationNotificationSettings)
      .sort()
      .map(name => {
        return {
          name,
          ...stationNotificationSettings[name],
        };
      });
  }, [stationNotificationSettings]);

  const columns = [
    {
      key: 'name',
      title: 'Name',
      render: (value, record) => {
        return (
          <div style={{ lineHeight: 1.3 }}>
            <div>{record.title || record.name}</div>
            {!!record.description && (
              <Text type="secondary" style={{ fontSize: 12 }}>
                {record.description}
              </Text>
            )}
          </div>
        );
      },
    },
    {
      key: 'isEnabled',
      title: 'Enabled',
      width: 120,
      render: (value, record) => {
        return (
          <Switch
            checked={!!record.isEnabled}
            onChange={(checked) => {
              onUpdate({
                name: 'STATION_NOTIFICATION_SETTING',
                action: 'UPDATE',
                key: record.name,
                value: {
                  isEnabled: checked,
                },
              });
            }}
          />
        );
      },
    },
    {
      key: 'isEmail',
      title: 'Email Enabled',
      width: 160,
      render: (value, record) => {
        return (
          <Switch
            checked={!!record.isEmail}
            onChange={(checked) => {
              onUpdate({
                name: 'STATION_NOTIFICATION_SETTING',
                action: 'UPDATE',
                key: record.name,
                value: {
                  isEmail: checked,
                },
              });
            }}
          />
        );
      },
    },
  ];

  return (
    station && stationNotificationSettings ? (
      <Table
        className="super-table"
        size="small"
        columns={columns}
        dataSource={dataSource.map((record) => ({
          ...record,
          key: record.name,
        }))}
        pagination={false}
      />
    ) : <SpinFull />
  );
};

